<template>
  <div>
    <Head title="Regjistrimi i barazimit" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/financat/barazimet-me-shofere-shperndares">Barazimet me shoferë</Link>
      <span class="text-indigo-400 font-medium">/</span> Regjistro
    </h1>
    <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
      <form>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
<!--          <select-input v-model="form.delivery_driver_id" :error="barazimForm.errors.delivery_driver_id" class="pb-8 pr-6 w-full"-->
<!--                        label="Shoferi shpërndarës"-->
<!--          >-->
<!--            <option :value="null">Zgjedh shoferin</option>-->
<!--            <option v-for="driver in deliveryDrivers" :key="driver.id" :value="driver.id">{{ driver.name }}</option>-->
<!--          </select-input>-->


          <div class="pb-8 pr-6 w-full">
            <label class="form-label">Zgjedh shoferin</label>
            <Multiselect
              v-model="form.delivery_driver_id"
              :options="filterDrivers.options"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
            />
            <div v-if="form.errors.delivery_driver_id" class="form-error">{{ form.errors.delivery_driver_id }}</div>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Gjithsejt dërgesa:</label>
            <p>{{barazim_data.shipping_orders + barazim_data.pending_orders + barazim_data.delivered_orders + barazim_data.cancelled_orders}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Në shpërndarje:</label>
            <p>{{barazim_data.shipping_orders}}</p>
          </div>


          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Në pritje:</label>
            <p>{{barazim_data.pending_orders}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Sukses:</label>
            <p>{{barazim_data.delivered_orders}}</p>
          </div>



          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Të anuluara:</label>
            <p>{{barazim_data.cancelled_orders}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Të anuluara:</label>
            <p>{{barazim_data.cancelled_orders}}</p>
          </div>

<!--          <div class="pb-8 pr-6 w-full lg:w-1/2">-->
<!--            <label class="font-bold">Kthime të mjeteve paguara nga shoferi:</label>-->
<!--            <p>{{moneyReturns.data.length}}</p>-->
<!--          </div>-->

<!--          <div class="pb-8 pr-6 w-full lg:w-1/2">-->
<!--            <label class="font-bold">Totali i kthimeve të mjeteve:</label>-->
<!--            <currency-number-format :number="`${barazim_data.money_return_cost}`"></currency-number-format>-->

<!--          </div>-->

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="font-bold">Totali për dorëzim:</label>
            <currency-number-format :number="`${barazim_data.expected_amount}`"></currency-number-format>
          </div>
        </div>


        <div class="flex items-center justify-between justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">

          <div class="flex flex-wrap items-start space-y-4 lg:space-y-0">

          <dropdown v-if="this.form.delivery_driver_id != null" class="mr-2 w-4 h-4" placement="bottom-start">
            <template #default>
              <icon name="print" class="mr-2 w-4 h-4"></icon>
            </template>
            <template #dropdown>
              <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                <a  class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="route('print.delivery-driver-balance.pdf',this.form)"  target="_blank">Printo PDF</a>
              </div>
            </template>
          </dropdown>

          <a v-if="this.form.delivery_driver_id != null" download :href="route('admin.finances.delivery-driver-barazimet.balance.excel',this.form)" class="pb-3 ml-2"><icon alt="Excel" class="w-4 h-4" name="excel"></icon></a>

          </div>


          <loading-button v-if="this.form.delivery_driver_id != null" :loading="form.processing" class="btn-indigo" type="button" @click="showBarazimModal = true">Regjistro barazim</loading-button>
          <Teleport to="body" >
            <!-- use the modal component, pass in the prop -->
            <modal :show="showBarazimModal" @close="showBarazimModal = false">
              <template #header>
                <h3>Plotësoni bankënotat e dorëzuara nga shoferi.</h3>
              </template>

              <template #body>

                <div class="flex flex-wrap">

<!--                  <div class="pb-2 pr-4 w-full lg:w-1/3" v-for="banknote in banknotes" :key="banknote.id">-->
<!--                    <label class="form-label">{{ banknote.value }}({{banknote.name}}):</label>-->
<!--                    <input v-model="banknote.total" class=" form-input focus:ring-0 hover:border-indigo-500"-->
<!--                                :value="0"-->
<!--                    />-->
<!--&lt;!&ndash;                    <div v-if="error" class="form-error">{{ error }}</div>&ndash;&gt;-->

<!--                  </div>-->

                  <number-input v-for="banknote in barazimForm.banknotes" v-model="banknote.total" :error="barazimForm.errors[`banknotes.${banknote.id}.total`]" class="pb-2 pr-4 w-full lg:w-1/3"
                              :label="`${banknote.value}(${banknote.name})`"
                  />


                  <number-input disabled v-model="barazimForm.delivered_amount" :error="barazimForm.errors.delivered_amount" class="pb-4 pr-6 w-full lg:w-1/2"
                              label="Shuma totale"
                  />

                  <div class="modal-header mb-2 w-full" >
                    <h3>Plotësoni shpenzimet e deklaruara nga shoferi.</h3>
                  </div>

                  <text-input v-model="barazimForm.petrol_expenses_amount" :error="barazimForm.errors.petrol_expenses_amount" class="pb-4 pr-6 w-full lg:w-1/3"
                              label="Shpenzimet për naftë"
                  />

                  <text-input v-model="barazimForm.personal_expenses_amount" :error="barazimForm.errors.personal_expenses_amount" class="pb-4 pr-6 w-full lg:w-1/3"
                              label="Shpenzime personale"
                  />

                  <text-input v-model="barazimForm.other_expenses_amount" :error="barazimForm.errors.other_expenses_amount" class="pb-4 pr-6 w-full lg:w-1/3"
                              label="Shpenzime tjera"
                  />

                  <div class="modal-header mb-2 w-full" >

                    <h3><input type="checkbox" class="mr-3" v-model="showAdditionalPackages" @click="toggleAdditionalPackages(!showAdditionalPackages)">Pako shtesë</h3>
                  </div>


                  <div v-if="showAdditionalPackages" v-for="(additionalPackage, index) in barazimForm.additional_packages" class="flex flex-wrap">
                    <text-input  class="pb-4 pr-6 w-full lg:w-1/3" v-model="additionalPackage.order_id" :error="barazimForm.errors[`additional_packages.${index}.order_id`]"
                                label="Dërgesa"/>

                    <text-input class="pb-4 pr-6 w-full lg:w-1/3" v-model="additionalPackage.packages" :error="barazimForm.errors[`additional_packages.${index}.packages`]"
                                label="Numri i pakove"/>

                    <div class="flex flex-wrap lg:flex-nowrap mb-6 mt-6 items-center justify-between">
                      <button class="ml-auto" type="button"><icon name="create" class="flex-shrink-0 mr-2 w-5 h-5 fill-green-600" @click="addPackage"/></button>
                      <button class="ml-auto" type="button"><icon name="trash" class="flex-shrink-0 ml-2 w-5 h-5 fill-red-600" @click="removePackage(index)"/></button>
                    </div>
                  </div>

                  <textarea-input v-model="barazimForm.additional_info" :error="barazimForm.errors.additional_info" class="pb-4 pr-6 w-full lg:w-full" label="Informata shtesë" />
                </div>
              </template>

              <template #footer>
                <div class="flex flex-wrap">
                  <loading-button class="btn-indigo bg-red-500"
                                  @click = "showBarazimModal = false"
                  >Anulo</loading-button>
                  <loading-button :loading="barazimForm.processing" class="btn-indigo ml-auto" type="button" @click="submitBarazimForm">Vazhdo</loading-button>
                </div>
              </template>
            </modal>
          </Teleport>
        </div>
      </form>
    </div>



    <div class="flex items-center mb-6">
      <h2 class="mt-12 text-2xl font-bold">Dërgesat e pabarazuara</h2>
    </div>

    <search-input v-model="form.search" class="mr-4 py-0 mb-6 w-full max-w-md" @reset="reset"></search-input>


    <div class="flex flex-wrap  mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label">Statusi:</label>
        <Multiselect
          v-model="form.status_ids"
          :options="filterStatuses.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label">Shteti:</label>
        <Multiselect
          v-model="form.country_ids"
          :options="filterCountries.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-gray-700">Qyteti:</label>
        <Multiselect
          v-model="form.city_ids"
          :options="filterCities.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />

      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label">Nga data e editimit të statusit:</label>
        <input v-model="form.start_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date_status_updated" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">
            <input :checked="allOrdersSelected" @click="selectAllOrders" class="flex items-center  px-2 py-4" type="checkbox">
          </th>
          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">Statusi</th>
          <th class="pb-4 pt-6 px-2">Biznesi shitës</th>

          <th class="pb-4 pt-6 px-2">Emri i blerësit</th>
          <th class="pb-4 pt-6 px-2">Telefoni i blerësit</th>
          <th class="pb-4 pt-6 px-2">Qyteti</th>
          <th class="pb-4 pt-6 px-2">Adresa</th>

          <th class="pb-4 pt-6 px-2">Sasia</th>
          <th class="pb-4 pt-6 px-2">Madhësia e pakos</th>
          <th class="pb-4 pt-6 px-2">Çmimi</th>

          <th class="pb-4 pt-6 px-2">Krijuar më</th>
          <th class="pb-4 pt-6 px-6" >Statusi edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">

          <td class="border-t px-2">
            <input v-model="order.selected" :value="order.id" class="flex items-center  px-2 py-4" type="checkbox">
          </td>

          <td class="w-px border-t">
            <a class="flex items-center  px-2 py-4" :href="`/admin/dergesat/${order.id}`" target="_blank" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </a>
          </td>

          <td class="border-t px-2">
            {{ order.id }}
            <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            <small v-if="order.is_change" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">NDËRRIM</small>
            <small v-if="order.is_cash && order.has_product" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">CASH</small>
            <icon v-if="order.product_returned" name="checkmark" class="block w-6 h-6 fill-green-600" title="Produkti eshte kthyer" />
            <small v-if="order.is_recreated" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">RINISJE</small>
            <small v-if="order.parent_id" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">BASHKIM</small>
          </td>
          <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getOrderStatusColor(order.status.id)">
                {{ order.status.name }}</span>
          </td>
          <td class="border-t px-2">
            {{ order.business.name }}
          </td>

          <td class="border-t px-2">
            {{ order.name }}
          </td>
          <td class="border-t px-2">
            {{ order.phone }}
          </td>
          <td class="border-t px-2">
            {{ order.city.name }}
          </td>

          <td class="border-t px-2">
            {{ order.address }}
          </td>

          <td class="border-t px-2">
            {{ order.quantity }}
          </td>
          <td class="border-t px-2">
            {{ order.package_size.name }}
          </td>
          <td class="border-t px-2">
            {{ order.product_price }}
          </td>

<!--          <td v-if="order.status.id === 7 || order.status.id === 8" class="border-t px-2">-->
<!--            {{ order.cancellation_price }}-->
<!--          </td>-->


          <td class="border-t px-2">
            {{ order.hr_created_at }}
          </td>
          <td class="border-t px-2">
            {{ order.updated_status_at }}
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje dërgesë.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="orders.meta" class="flex flex-wrap">
<!--      <select-input v-model="form.per_page"  class="p-0 mt-6 mr-5 w-1/4 lg:w-1/12"-->
<!--      >-->
<!--        <option v-if="orders.meta.total > 15" value="15">15 / {{orders.meta.total}}</option>-->
<!--        <option v-if="orders.meta.total > 30"  value="30">30 / {{orders.meta.total}}</option>-->
<!--        <option v-if="orders.meta.total > 50"  value="50">50 / {{orders.meta.total}}</option>-->
<!--        <option v-if="orders.meta.total > 100"  value="100">100 / {{orders.meta.total}}</option>-->
<!--        <option :value="orders.meta.total">{{orders.meta.total}} / {{orders.meta.total}}</option>-->

<!--      </select-input>-->
<!--      <pagination class="mt-6" :links="orders.meta.links"/>-->
    </div>


<!--    <div  class="flex items-center mb-6">-->
<!--      <h2 class="mt-12 text-2xl font-bold">Kthimet e mjeteve</h2>-->
<!--    </div>-->

<!--    <div class="bg-white rounded-md shadow overflow-x-auto">-->
<!--      <table class="w-full whitespace-nowrap">-->
<!--        <thead>-->
<!--        <tr class="text-left font-bold">-->
<!--          <th class="pb-4 pt-6 px-6"></th>-->
<!--          <th class="pb-4 pt-6 px-6">ID</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Statusi</th>-->
<!--          <th class="pb-4 pt-6 px-6">Dërgesa</th>-->
<!--          <th class="pb-4 pt-6 px-6">Kthimi i dërgesës</th>-->
<!--          <th class="pb-4 pt-6 px-6">Biznesi shitës</th>-->
<!--          <th class="pb-4 pt-6 px-6">Pika marrëse</th>-->
<!--          <th class="pb-4 pt-6 px-6">Shuma e mjeteve</th>-->
<!--          <th class="pb-4 pt-6 px-6">Emri i blerësit</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Telefoni i blerësit</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Qyteti</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Adresa</th>-->
<!--          <th class="pb-4 pt-6 px-6" >Krijuar më</th>-->
<!--        </tr>-->
<!--        </thead>-->
<!--        <tbody>-->
<!--        <tr v-for="moneyReturn in moneyReturns.data" :key="moneyReturn.id" class="hover:bg-gray-100 focus-within:bg-gray-100">-->
<!--          <td class="w-px border-t">-->
<!--            <a class="flex items-center  px-2 py-4" :href="`/admin/mjetet/${moneyReturn.id}`" target="_blank" tabindex="-1">-->
<!--              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />-->
<!--            </a>-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.id }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getMoneyReturnStatusColor(moneyReturn.status_id)">{{ moneyReturn.status }}</span>-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            <a class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`/admin/dergesat/${moneyReturn.order_id}`">-->
<!--              {{ moneyReturn.order_id }}-->
<!--            </a>-->
<!--          </td>-->
<!--          <td  class="border-t px-2">-->
<!--            <a  class="flex items-center px-6 py-4 focus:text-indigo-500" target="_blank" :href="`/admin/nderrimet/${moneyReturn.order_change_id}`">-->
<!--              {{ moneyReturn.order_change_id}}-->
<!--            </a>-->
<!--          </td>-->
<!--          <td  class="border-t px-2">-->
<!--            {{ moneyReturn.business }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.paid_by_seller ? moneyReturn.location : 'Mjetet te mirren nga posta' }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.amount }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.client }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.phone }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.city }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.address }}-->
<!--          </td>-->
<!--          <td class="border-t px-2">-->
<!--            {{ moneyReturn.hr_created_at }}-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr v-if="moneyReturns.data.length === 0">-->
<!--          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë rekord.</td>-->
<!--        </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import CurrencyNumberFormat from '@/Shared/CurrencyNumberFormat'
import SearchInput from '@/Shared/SearchInput'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import TextareaInput from '@/Shared/TextareaInput'
import Modal from '@/Shared/Modal'
import Pagination from '@/Shared/Pagination'
import NumberInput from '@/Shared/NumberInput'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    SearchInput,
    CurrencyNumberFormat,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
    Dropdown,
    TextareaInput,
    Modal,
    Pagination,
    NumberInput,
    Multiselect
  },
  layout: Layout,
  props:{
    deliveryDrivers: Array,
    orders: Object,
    moneyReturns: Object,
    filters: Object,
    barazim_data: Object,
    banknotes: Array,
    countries: Array,
    statuses: Array,
    cities: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        delivery_driver_id: this.filters.delivery_driver_id ?? null,
        search: this.filters.search,
        // per_page: this.orders.meta.total < 15 ? this.orders.meta.total : this.orders.meta.per_page,
        country_ids: this.filters.country_ids,
        city_ids: this.filters.city_ids,
        status_ids: this.filters.status_ids,
        start_date_status_updated: this.filters.start_date_status_updated,
        end_date_status_updated: this.filters.end_date_status_updated
      }),
      barazimForm: this.$inertia.form({
        delivery_driver_id: null,
        delivered_amount: 0.00,
        petrol_expenses_amount: null,
        personal_expenses_amount: null,
        other_expenses_amount: null,
        additional_info: null,
        currentOrderSelections: null,
        banknotes: this.banknotes,
        additional_packages: []
      }),
      showBarazimModal: false,
      showAdditionalPackages: false,
      filterCountries: {
        options: this.countries.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterStatuses: {
        options: this.statuses.map(function(status){
          return {value: status.id, label: status.name}
        }),
      },
      filterCities: {
        options: this.cities.map(function(city){
          return {value: city.id, label: city.name}
        }),
      },
      filterDrivers: {
        options: this.deliveryDrivers.map(function(driver){
          return {value: driver.id, label: driver.name}
        }),
      },
    }
  },
  mounted() {
    this.orders.data.forEach((order) => order['selected'] = false);
    this.banknotes.forEach((banknote) => banknote['total'] = 0);
  },
  computed:{
    allOrdersSelected(){
      return this.orders.data.every(order => order.selected)
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/financat/barazimet-me-shofere-shperndares/regjistro',pickBy(this.form),{
          preserveScroll: true,
          preserveState: true,
        })
        this.barazimForm.delivery_driver_id = this.form.delivery_driver_id
      }, 150)
    },
    orders: {
      handler() {
        this.barazimForm.currentOrderSelections = this.orders.data
          .filter( order => order.selected )
          .map( order => order.id )
          .toString();
      },
      deep: true
    },
    // barazimForm: {
    //   deep: false,
    //   handler: throttle(function(){
    //     let totalAmount = 0
    //     this.barazimForm.banknotes.forEach((banknote) => {
    //       console.log(banknote)
    //       totalAmount += (banknote.value * banknote.total)
    //     })
    //     this.barazimForm.delivered_amount += totalAmount
    //   },150)
    // },
    'barazimForm.banknotes': {
      deep: true,
      handler() {
        let totalAmount = 0
        this.barazimForm.banknotes.forEach((banknote) => {
          totalAmount += (banknote.value * banknote.total)
        })
        this.barazimForm.delivered_amount = parseFloat(totalAmount).toFixed(2)
      }
    }
  },
  methods: {
    reset(){
      this.form.search = ''
      this.form.start_date_status_updated = ''
      this.form.end_date_status_updated = ''

      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    submitBarazimForm(){
      var self = this;
      this.barazimForm.post('/admin/financat/barazimet-me-shofere-shperndares',{
        onError(errors){
          if(errors.delivered_amount)
            self.showBarazimModal = true
          else
            self.showBarazimModal = false
        },
        onSuccess(){
          self.showBarazimModal = false
        }
      })
    },
    selectAllOrders(){
      let allS = this.allOrdersSelected;
      this.orders.data.forEach(order => order.selected = !allS)
    },
    toggleAdditionalPackages(show){
      if(show){
        this.showAdditionalPackages = true
        this.addPackage()
      }else {
        this.showAdditionalPackages = false
        this.barazimForm.additional_packages = []
      }
    },
    addPackage(){
      this.barazimForm.additional_packages.push({ order_id : null, packages: null})
    },
    removePackage(index){
      if(this.barazimForm.additional_packages.length > 1){
        this.barazimForm.additional_packages.splice(index,1)
        this.barazimForm.errors = []
      }
    },
    getOrderStatusColor(statusId){
      let statusColor = 'bg-indigo-500'
      if(statusId === 1)
        statusColor = 'bg-yellow-500'

      if(statusId === 3)
        statusColor = 'bg-orange-500'

      if(statusId === 4)
        statusColor = 'bg-indigo-900'

      if(statusId === 5)
        statusColor = 'bg-green-500'

      if(statusId === 6)
        statusColor = 'bg-yellow-700'

      if(statusId === 7)
        statusColor = 'bg-red-500'

      if(statusId === 8)
        statusColor = 'bg-gray-400'

      if(statusId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    },
    getMoneyReturnStatusColor(moneyReturnStatusId){
      let color = 'bg-indigo-500'
      if (moneyReturnStatusId === 1)
        color = 'bg-yellow-500'

      if (moneyReturnStatusId === 3)
        color = 'bg-orange-500'

      if (moneyReturnStatusId === 4)
        color = 'bg-indigo-900'

      if (moneyReturnStatusId === 5)
        color = 'bg-green-500'

      if (moneyReturnStatusId === 6)
        color = 'bg-red-500'


      return color
    },
  },

}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
